import edapWrapper from '@homeaway/edap-wrapper';

const windowOptions =
    'scrollbars=yes,resizable=yes,toolbar=no,location=yes,height=420,width=550';

const triggerEvent = (eventaction) => {
    edapWrapper().push({
        name: 'generic.event',
        data: {
            eventcategory: 'content hub activity',
            eventaction,
        },
    });
};

const getEncodedUrl = () => {
    return encodeURIComponent(window.location.href);
};

const facebook = () => {
    triggerEvent('facebook share click');
    const shareUrl = `https://www.facebook.com/sharer.php?u=${getEncodedUrl()}`;
    window.open(shareUrl, 'FB_SHARE_WINDOW', windowOptions);
};

const twitter = () => {
    triggerEvent('twitter share click');
    const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        document.title,
    )} ${getEncodedUrl()}`;

    window.open(shareUrl, 'TWITTER_SHARE_WINDOW', windowOptions);
};

const linkedin = () => {
    triggerEvent('linkedin share click');
    const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${getEncodedUrl()}`;
    window.open(shareUrl, 'LINKEDIN_SHARE_WINDOW', windowOptions);
};

const email = () => {
    triggerEvent('email share click');
    window.location.replace(
        `mailto:?subject=${document.title}&body=${getEncodedUrl()}`,
    );
};

const copyLink = () => {
    triggerEvent('copy link clicked');
    const tempElement = document.createElement('input');
    document.body.appendChild(tempElement);
    tempElement.value = window.location.href;
    tempElement.select();
    document.execCommand('copy');
    document.body.removeChild(tempElement);
};

const whatsapp = () => {
    triggerEvent('whatsapp share click');
    const shareUrl = `https://api.whatsapp.com/send?text=${getEncodedUrl()}`;
    window.open(shareUrl, 'WHATSAPP_SHARE_WINDOW', windowOptions);
};

export {facebook, twitter, linkedin, email, copyLink, whatsapp};
